import { FC, ReactNode } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { Article } from "@/lib/types/Article";
import { useAppContext } from "@/src/config/AppProvider";
import useBrowserRoutes from "@/src/utils/helpers/useBrowserRoutes";

interface NavigationsProps {
  children?: ReactNode;
}

const Navigations: FC<NavigationsProps> = ({ children }) => {
  const { t } = useTranslation();
  const routes = useBrowserRoutes();
  const { mobile, setMobile } = useAppContext();

  const onClickLink = () => {
    setMobile(!mobile);
  };

  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        {children}
        <li>
          <Link href="/" onClick={onClickLink}>
            {t("homePage")}
          </Link>
        </li>
        <ProgramsNavigation onClick={onClickLink} />
        <li>
          <Link href={routes.articles} onClick={onClickLink}>
            {t("articles")}
          </Link>
        </li>
        <li>
          <Link href={routes.aboutUs} onClick={onClickLink}>
            {t("aboutUs")}
          </Link>
        </li>
        <li>
          <Link href={routes.team} onClick={onClickLink}>
            {t("ourTeam")}
          </Link>
        </li>
        <li>
          <Link href={routes.contact} onClick={onClickLink}>
            {t("contactUs")}
          </Link>
        </li>
      </ul>
    </nav>
  );
};

interface ProgramsNavigationProps {
  onClick: () => void;
}

const ProgramsNavigation: FC<ProgramsNavigationProps> = ({ onClick }) => {
  const { programs, getLocalization } = useAppContext();
  const { t } = useTranslation();
  const routes = useBrowserRoutes();

  const firstHalf = programs?.slice(0, 5);
  const secondHalf = programs?.slice(5, Math.min(10, programs.length));

  return (
    <li className="with-megamenu has-menu-child-item">
      <Link href={routes.programs} onClick={onClick}>
        {t("programs")}
        <i className="feather-chevron-down"></i>
      </Link>
      <div
        className="rbt-megamenu grid-item-2"
        style={{
          left: "-80px"
        }}
      >
        <div className="wrapper">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="mega-top-banner"
                style={{
                  backgroundImage: `url(/img/programMenuImage.jpg), radial-gradient(100% 100% at 100% 0%, #484C7A 0%, #23263B 100%)`
                }}
              >
                <div className="content">
                  <h4 className="title">{t("programs")}</h4>
                  <p className="description">{getLocalization("ourProgramsSlogan")}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row row--15">
            <ProgramList programs={firstHalf} />
            <ProgramList programs={secondHalf} />
          </div>
          <div className="row">
            <div className="col-lg-12">
              <ul className="nav-quick-access">
                <li>
                  <Link href={routes.programs}>
                    <i className="feather-arrow-right-circle"></i>
                    {t("allPrograms")}
                  </Link>
                </li>
                <li>
                  <Link href={routes.contact}>
                    <i className="feather-phone"></i>
                    {t("contactUs")}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

const ProgramList = ({ programs }: { programs: Article[] }) => {
  const routes = useBrowserRoutes();

  return (
    <div className="col-lg-12 col-xl-6 col-xxl-6 single-mega-item">
      <ul className="mega-menu-item">
        {programs?.map(item => {
          const detailLink = routes.programDetail.replace(":slug", item.Slug);
          return (
            <li key={item.IdGuid}>
              <Link href={detailLink}>{item.Title}</Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Navigations;
